import { createSelector } from 'reselect';

const photoSelector = state => state.photos;

export const current = createSelector(photoSelector, state => state.current);
export const photos = createSelector(photoSelector, state => state.photos);
export const page = createSelector(photoSelector, state => state.page);
export const count = createSelector(photoSelector, state => state.count);
export const userOptions = createSelector(photoSelector, state => state.userOptions);
export const query = createSelector(photoSelector, state => state.query);
